
// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getNotificationsProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetAllNotificationsProfessionalApi = createAsyncThunk(
  "hitGetAllNotificationsProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getNotificationsProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetAllNotificationsProfessionalSlice = createSlice({
  name: "getAllNotificationsProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
    status: null,
    isError: false,
  },
  reducers: {
    clearhitGetAllNotificationsProfessionalData: (state) => {
      state.data = null;
      state.status = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetAllNotificationsProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetAllNotificationsProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = action.payload.status;
        state.data = action.payload;
      })
      .addCase(hitGetAllNotificationsProfessionalApi.rejected, (state) => {
          state.status = false;
        state.isError = false;
        
      });
  },
});

export const { clearhitGetAllNotificationsProfessionalData } = GetAllNotificationsProfessionalSlice.actions;
export default GetAllNotificationsProfessionalSlice.reducer;